import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/event/2604_sapporo_collection.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-1d18ef07")

_pushScopeId("data-v-1d18ef07")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "header-section" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "header-banner",
    src: _imports_0
  }),
  /*#__PURE__*/_createVNode("a", {
    class: "detail-btn",
    href: "https://onlylive.tokyo/event_t/2604",
    target: "_blank"
  }, [
    /*#__PURE__*/_createVNode("span", null, "イベント詳細はこちら")
  ])
], -1)
const _hoisted_3 = { class: "ranking-body-section" }
const _hoisted_4 = {
  class: "ranking-section",
  id: "ranking"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Ranking = _resolveComponent("Ranking")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_Ranking, {
          event: _ctx.state.event,
          rankingUsers: _ctx.state.ranking,
          tallyStartDays: 3,
          tallyEndDays: 3,
          maxCount: 7
        }, null, 8, ["event", "rankingUsers"])
      ])
    ])
  ]))
})